module.exports = "<div class=\"items flex-row grid\">\n  <div class=\"videoblock\" ng-class=\"{'last' : (($index+1) % rowcount)==0}\" ng-repeat=\"video in videos\">\n    <video-block video=\"video\" no-link=\"true\"></video-block>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/core_theme_2/src/templates/directives/comingSoonVideos.html
// module id = 155
// module chunks = 0